import { render, staticRenderFns } from "./PlanAheadMenuItem.vue?vue&type=template&id=04015394"
import script from "./PlanAheadMenuItem.vue?vue&type=script&lang=js"
export * from "./PlanAheadMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports